import React from 'react' 

const Text = ({children}) => (
  <div className="w-100 py-1 px-2">{children}</div>
)


export default Text

